import { selectFaceliftEnabled } from '@pressreader/appcore';
import { select } from '@pressreader/appstore';
import { computeScreenInfo } from '@pressreader/ui-common';
import { ScreenSizeType } from '@pressreader/ui-types';

function markScreenType(htmlElement: HTMLHtmlElement) {
    const screenInfo = computeScreenInfo();

    if (screenInfo.screenType <= ScreenSizeType.Small) {
        htmlElement.classList.add('pr-mobile');
    } else {
        htmlElement.classList.add('pr-desktop');
    }
}

function markAppAsV2() {
    const htmlElement = document.getElementsByTagName('html').item(0);

    markScreenType(htmlElement);
    htmlElement.classList.add('pr-v2');
}

function markAppAsLegacy() {
    const htmlElement = document.getElementsByTagName('html').item(0);

    markScreenType(htmlElement);

    // set html tag to have 'pr-legacy' if it wasn't loaded as part of a react version
    if (!htmlElement.classList.contains('pr-v2')) {
        htmlElement.classList.add('pr-legacy');
    }
}

function isAppLegacy(): boolean {
    const htmlElement = document.getElementsByTagName('html').item(0);
    return htmlElement.classList.contains('pr-legacy');
}

function markLegacyDark() {
    const isFaceLiftEnabled = select(selectFaceliftEnabled);
    const documentElement = document.documentElement;

    if (!documentElement.classList.contains('pr-v2')) {
        documentElement.classList.add('se2sky-legacy');
    }

    if (!isFaceLiftEnabled) {
        documentElement.classList.add('feat-pageview--dark');
    }
}

export { isAppLegacy, markAppAsLegacy, markAppAsV2, markLegacyDark };
